import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';
import AvatarEditor from 'react-avatar-editor';

import Avatar from 'app/avatar';

// Display-only avatar that renders the image through react-avatar-editor using the
// saved zoom + crop position, so the thumbnail matches exactly what the user cropped
// in the Edit Photo modal. Falls back to the initials Avatar when there's no image.
const CroppedAvatar = ({ url, size, zoom, position, circular, name }) => {
  if (!url) return <Avatar name={name} size={size} />;

  return (
    <Box
      css="flex: 0 0 auto; line-height: 0; pointer-events: none;"
      sx={{ width: `${size}px`, height: `${size}px`, borderRadius: circular ? '50%' : '8px', overflow: 'hidden' }}
    >
      <AvatarEditor
        image={url}
        width={size}
        height={size}
        border={0}
        borderRadius={circular ? size / 2 : 8}
        scale={zoom || 1}
        position={position}
        disableBoundaryChecks
      />
    </Box>
  );
};

CroppedAvatar.propTypes = {
  url: PropTypes.string,
  size: PropTypes.number,
  zoom: PropTypes.number,
  position: PropTypes.shape({ x: PropTypes.number, y: PropTypes.number }),
  circular: PropTypes.bool,
  name: PropTypes.string,
};

CroppedAvatar.defaultProps = {
  url: '',
  size: 40,
  zoom: 1,
  position: undefined,
  circular: true,
  name: '',
};

export default CroppedAvatar;
